import React, { useEffect, useState } from "react";
import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";

import FormDrawer from "components/Shared/FormDrawer";
import ShipmentRouteForm from "./ShipmentRoutesForm";
import ShipmentRouteList from "./ShipmentRouteList";
import { useShipmentDetailContext } from "contexts/ShipmentDetailContext";
import {
  useAddShipmentRouteMutation,
  useLazyListShipmentRoutesQuery,
} from "store/services/shipmentApi";
import { useAuth } from "hooks";

const ShipmentRoutesTab = () => {
  const { isCustomer, isVendor, isContractor, isDriver, isVendorStaff } = useAuth();
  const canEdit = isCustomer || isVendor || isContractor || isDriver || isVendorStaff;
  const [showRouteForm, setShowRouteForm] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [latestEndStop, setLatestEndStop] = useState(null);
  const { ShipmentDetail } = useShipmentDetailContext();
  const shipmentId = ShipmentDetail?._id;

  const [fetchRoutes, { data: routesRes, isLoading: loadingRoutes }] = useLazyListShipmentRoutesQuery();
  const [addRoute, { isLoading: addingRoute }] = useAddShipmentRouteMutation();

  const handleCancelRoute = () => {
    setShowRouteForm(false);
    setSelectedRoute(null);
  };

  const handleAddRoute = async (data) => {
    try {
      if (!data.account || !data.entity || !data.route || !data.routeStartStop) {
        toast.error("All fields are required");
        return;
      }

      await addRoute({
        shipmentId: data.shipmentId,
        account: data.account,
        entity: data.entity,
        route: data.route,
        routeStartStop: data.routeStartStop,
        routeEndStop: data.routeEndStop,
        comments: data.comments,
      }).unwrap();
      toast.success("Route successfully added!");
      setLatestEndStop(data.routeEndStop); // Set full branch object
      handleCancelRoute();
      fetchRoutes({ shipmentId });
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add route!");
    }
  };

  useEffect(() => {
    if (shipmentId) {
      fetchRoutes({ shipmentId });
    }
  }, [shipmentId, fetchRoutes]);

  return (
    <>
      {!canEdit && (<Box display="flex" justifyContent="end" padding={3}>
        {!showRouteForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            disabled={ShipmentDetail?.isActive === false}
            onClick={() => setShowRouteForm(true)}
          >
            Add Route
          </Button>
        )}
      </Box>)}
      <ShipmentRouteList
        routes={routesRes || []}
        isLoading={loadingRoutes}
        latestEndStop={latestEndStop}
        setLatestEndStop={setLatestEndStop}
      />
      <FormDrawer
        title="Shipment Route"
        open={showRouteForm}
        onClose={handleCancelRoute}
      >
        <ShipmentRouteForm
          isBusy={addingRoute}
          route={selectedRoute}
          shipmentId={shipmentId}
          latestEndStop={latestEndStop}
          setLatestEndStop={setLatestEndStop}
          onCancel={handleCancelRoute}
          onSubmit={handleAddRoute}
        />
      </FormDrawer>
    </>
  );
};

export default ShipmentRoutesTab;